import api from "../../../services/api";

// Fonte real da tabela de "Incidentes" e da "Linha do tempo global" — as duas
// rotas compartilham o mesmo motor no backend (incidentesPeriodo.js), então
// buscamos as duas juntas aqui também: se chegarem quase ao mesmo tempo, o
// dedup do backend evita computar 2x.
//
// Os filtros de cliente/equipamento JÁ são enviados: desde a rota
// /find/centralAlertas/filtros os dropdowns usam ids reais (Clientes.id e
// hostId do Zabbix), que o backend honra em todas as rotas do dashboard.
export async function buscarIncidentesPeriodo({
	inicio,
	fim,
	filterClientes,
	filterEquipamentos,
	filterSeveridades,
	erpId,
	signal,
}) {
	const body = {
		initial_date: inicio.toISOString(),
		final_date: fim.toISOString(),
		// ERP escolhido no painel (sem ERP cadastrado: a variável ERP).
		erpId: erpId || undefined,
		...(filterClientes?.length ? { filterClientes } : {}),
		...(filterEquipamentos?.length ? { filterEquipamentos } : {}),
		...(filterSeveridades?.length ? { filterSeveridades } : {}),
	};

	const [incidentes, eventos] = await Promise.allSettled([
		api.post("/find/centralAlertas/incidentes", body, { signal }),
		api.post("/find/centralAlertas/linhaDoTempo", body, { signal }),
	]);

	if (incidentes.status === "rejected") {
		console.error(
			"Erro ao buscar incidentes da Central de Alertas:",
			incidentes.reason
		);
	}
	if (eventos.status === "rejected") {
		console.error(
			"Erro ao buscar linha do tempo da Central de Alertas:",
			eventos.reason
		);
	}

	// /incidentes responde { incidentes, ocultos, janelaCorrelacaoMinutos } —
	// `ocultos` é quantos alertas a configuração de exibição (tela /config)
	// tirou do painel, para a tela avisar em vez de sumir com o dado em
	// silêncio; `janelaCorrelacaoMinutos` é a janela de correlação em vigor
	// (aba Parâmetros da /config), usada nos textos de zona morta/correlação.
	return {
		incidentes:
			incidentes.status === "fulfilled"
				? incidentes.value?.data?.incidentes || []
				: [],
		ocultos:
			incidentes.status === "fulfilled"
				? incidentes.value?.data?.ocultos || 0
				: 0,
		janelaCorrelacaoMinutos:
			incidentes.status === "fulfilled"
				? incidentes.value?.data?.janelaCorrelacaoMinutos || null
				: null,
		// Janela do cluster de incidentes em vigor (0/null = desligado) —
		// usada no tooltip do marco "Incidente" da linha do tempo.
		janelaAgrupamentoMinutos:
			incidentes.status === "fulfilled"
				? incidentes.value?.data?.janelaAgrupamentoMinutos || null
				: null,
		eventos: eventos.status === "fulfilled" ? eventos.value?.data || [] : [],
	};
}

// Histórico de incidentes de UM equipamento, independente dos filtros da
// tela — usado pelo modal "Analisar padrão" (components/centralDeAlertas/
// analisePadrao). Reusa a rota /incidentes com filterEquipamentos de 1 item;
// o cache/dedup do motor no backend absorve aberturas repetidas do modal.
export async function buscarIncidentesEquipamento({
	equipamentoId,
	inicio,
	fim,
	erpId,
	signal,
}) {
	const resposta = await api.post(
		"/find/centralAlertas/incidentes",
		{
			initial_date: inicio.toISOString(),
			final_date: fim.toISOString(),
			filterEquipamentos: [equipamentoId],
			erpId: erpId || undefined,
		},
		{ signal },
	);
	return resposta?.data?.incidentes || [];
}
